import ProviderIcon from "./ProviderIcon"

export default ProviderIcon
